/** EN catalog — FE-5: calendar, bookings, My Day, Smart Scheduling. */
export const schedEn: Record<string, string> = {
  'cal.title': 'Calendar',
  'cal.subDay':
    'One day, every practitioner side by side. By room lays the same day out by rooms instead.',
  'cal.subWeek':
    'All seven days, 08:00–22:00 behind a scroll. Every booking carries its service name; tinted and hatched layers say why a time is unavailable.',
  'cal.subList':
    'The same calendar as a table: for finding, filtering and review — on the frozen pagination contract.',
  'cal.mine.sub': 'Your own schedule: the bookings in your name, by day, by week, or as a list.',
  'cal.mine.colSub': 'Your bookings',
  'cal.new': 'New booking',
  'cal.newGroup': 'New group session',
  'cal.f.online': 'Online',
  'grp.block': 'Group session',
  'grp.count': '{n, plural, =0 {No attendees yet} one {# attendee} other {# attendees}}',
  'grp.countOf': '{n, number} of {cap, number} attendees',
  'grp.exec.scheduled': 'Scheduled',
  'grp.exec.in_progress': 'In progress',
  'grp.exec.completed': 'Ended',
  'grp.exec.cancelled': 'Cancelled',
  'cal.view.day': 'Day',
  'cal.view.week': 'Week',
  'cal.view.list': 'List',
  'cal.lens.practitioner': 'By practitioner',
  'cal.lens.room': 'By room',
  'cal.earlier': 'Earlier',
  'cal.today': 'Today',
  'cal.later': 'Later',
  'cal.f.practitioner': 'Practitioner',
  'cal.f.room': 'Room',
  'cal.f.service': 'Service',
  'cal.f.status': 'Status',
  'cal.f.mode': 'Delivery',
  'cal.f.patient': 'Patient',
  'cal.f.all': 'All',
  'cal.noRoomCol': 'No room',
  'cal.noRoomColSub': 'Bookings without an assigned room',
  'cal.f.bookedOnly': 'Booked only',
  'cal.f.cancelled': 'Cancelled',
  'cal.f.noShow': 'No-show',
  'cal.f.range': 'Range',
  'cal.range.day': 'This day',
  'cal.range.week': 'This week',
  'cal.range.month': '31 days',
  'cal.noColumns':
    'No practitioners to lay out — pick one in the filter, or add practitioner profiles in Clinic setup.',
  'cal.noRooms': 'No rooms to lay out — add rooms in Clinic setup.',
  'cal.empty': 'Nothing booked in this range.',
  'cal.holiday.label': 'Official holiday',
  'cal.holiday.inRange': 'Official holidays in this range',
  'cal.outside': 'Outside working hours',
  'cal.absence': 'Time off',
  'cal.blockout': 'Room unavailable',
  'cal.legendTitle': 'Legend',
  'cal.group.speech': 'Speech therapy',
  'cal.group.ot': 'Occupational therapy',
  'cal.group.assess': 'Assessment & consultation',
  'cal.group.coach': 'Parent coaching',
  'cal.group.other': 'Other services',
  'cal.legendGhost': 'Cancelled / no-show',
  'cal.legendOutside': 'Outside working hours',
  'cal.legendAbsence': 'Time off / room unavailable',
  'cal.agendaSub': 'On the phone the day is a list — the same filters sit above it.',
  'cal.listNoSearch':
    'Find by patient: pick one with the Patient filter. The booking query has no free-text search by design.',
  'cal.colWhen': 'When',
  'cal.colPatient': 'Patient',
  'cal.colService': 'Service',
  'cal.colPractitioner': 'Practitioner',
  'cal.colMode': 'Mode · Room',
  'cal.colStatus': 'Status',
  'cal.pickPatient': 'Pick a patient',
  'cal.clearPatient': 'Any patient',
  'cal.slotHint': 'Tap a free time to start a booking there.',
  'cal.tooWide': 'This range is wider than the clinic system serves at once (93 days).',

  'bk.status.booked': 'Booked',
  'bk.status.cancelled': 'Cancelled',
  'bk.status.no_show': 'No-show',
  'bk.delivered': 'Delivered',
  'bk.mode.in_clinic': 'In clinic',
  'bk.mode.off_site': 'At home',
  'bk.mode.online': 'Online',
  'bk.modeNotOffered':
    'This service is not offered in this mode — enable it under Clinic setup › Services.',
  'bk.modeNotOfferedChip': 'Not offered',
  // ZOY-684: the join destination of an online session.
  'bk.dest.title': 'Where the session is joined',
  'bk.dest.hosted': 'Zoyaar video',
  'bk.dest.hostedBody':
    'Hosted by Zoyaar. The therapist enters from here; the family joins from the app. Opens 15 minutes before the start.',
  'bk.dest.external': 'External meeting link',
  'bk.dest.externalBody':
    'A link on another product (Google Meet, Skyroom…). The family receives it through the app.',
  'bk.dest.url': 'Meeting link',
  'bk.dest.urlHelp': 'A full https:// link. Stored as given; never shown on payment pages.',
  'bk.dest.urlInvalid': 'Enter a full https:// link without a username or password in it.',
  'bk.dest.pickOne': 'An online session needs a destination before it can be saved.',
  'bk.dest.fact': 'Join',
  'bk.dest.copy': 'Copy link',
  'bk.dest.copied': 'Copied',
  'bk.dest.open': 'Open link',
  'bk.dest.none': 'No destination yet',
  'bk.dest.leaveOnlineTitle': 'Leave the online mode?',
  'bk.dest.leaveOnlineBody':
    'The join destination is cleared with the mode — the family will no longer have a way to join online. The link can be entered again if the session goes back online.',
  'bk.dest.leaveOnlineCta': 'Change the mode',
  'bk.enter': 'Enter session',
  'bk.enterHint': 'Opens 15 minutes before the start and stays open until the scheduled end.',
  'bk.enterBefore': 'The door opens 15 minutes before the start.',
  'bk.enterClosed': 'The session is over — the door is closed.',
  'bk.enterErr.ONLINE_SESSION_NOT_HOSTED': 'This session is not hosted by Zoyaar.',
  'bk.enterErr.ONLINE_SESSION_NOT_READY':
    'The video room is not ready yet — the platform has not answered. Try again in a moment.',
  'bk.enterErr.ONLINE_SESSION_JOIN_WINDOW_CLOSED':
    'The door is closed: before 15 minutes to the start, or after the scheduled end.',
  'bk.enterErr.ONLINE_SESSION_PLATFORM_UNAVAILABLE':
    'The video platform did not answer — try again.',
  // Product 2026-09-16: the T−15 lock.
  'bk.lockedNote':
    'The online session has opened (15 minutes before the start), so it can no longer be moved or cancelled. No-show, start and delivery stay open.',
  'bk.lockedShort': 'Opened — no longer movable',
  'bk.v.BOOKING_ROOM_NOT_ALLOWED_ONLINE': 'An online session has no room.',
  'bk.v.BOOKING_JOIN_DESTINATION_REQUIRES_ONLINE':
    'A join destination belongs to an online session only.',
  'bk.v.BOOKING_JOIN_URL_INVALID':
    'The meeting link must be a full https:// address without credentials.',
  'bk.v.BOOKING_JOIN_URL_NOT_ALLOWED': 'A meeting link goes with an external destination only.',
  'bk.v.BOOKING_GROUP_PARTICIPATION_FOLLOWS_OCCURRENCE':
    'This booking is part of a group session — the time is moved on the group session itself.',
  'bk.v.BOOKING_ONLINE_SESSION_LOCKED':
    'The online session has already opened; it can no longer be moved or cancelled.',
  'bk.v.SUGGEST_LOCATION_NOT_ENABLED': 'The service is not offered in this delivery mode.',
  // ZOY-685: a participant's booking page.
  'bk.groupChip': 'Group session',
  'bk.groupPart':
    'Part of a group session — its time, therapist, room and destination are managed on the group session; this booking keeps its own package, delivery and payment.',
  'bk.openGroup': 'Open the group session',
  'bk.isGroupServiceTitle': 'This is a group service',
  'bk.isGroupServiceBody':
    'Group services run as one session with several attendees. Create the group session, then add its attendees — nothing here is booked for one patient.',
  'bk.isGroupServiceCta': 'Create a group session instead',
  'bk.next': 'Next',
  'bk.past': 'past',

  'bk.newTitle': 'New booking',
  'bk.newSub':
    'A booking starts from a slot, names its service, resolves who it is for in the same flow, and continues. Everything stays editable until it is saved.',
  'bk.newSubFrom':
    'Started from {when} in {who}’s column — everything stays editable until it is saved.',
  'bk.step1': '1 · Service and who it is for',
  'bk.step2': '2 · Time, practitioner, place',
  'bk.service': 'Service',
  'bk.serviceHelp':
    'No booking exists without a service. From the catalogue; enabled services only.',
  'bk.for': 'For',
  'bk.forHelp':
    'Resolved inside this same flow: an established patient continues; a first contact goes through the number lookup and minimal capture. First contacts are always booked manually — never through Smart Scheduling.',
  'bk.changePatient': 'Change',
  'bk.practitioner': 'Practitioner',
  'bk.practitionerHelp': 'Only practitioners capable of this service are offered.',
  'bk.noCapable':
    'No practitioner holds the capability for this service yet — grant it in Clinic setup › Services.',
  'bk.date': 'Date',
  'bk.from': 'From',
  'bk.duration': 'Duration',
  'bk.durationHelp': 'Prefilled from the service’s default — change it freely.',
  'bk.min': 'min',
  'bk.mode': 'Delivery mode',
  'bk.modeHelp':
    'In clinic may use a room; at home puts the visit’s address on the booking; online is joined through a meeting link or Zoyaar video.',
  'bk.room': 'Room',
  'bk.roomHelp':
    'Never picked automatically, and not always required; only rooms that support this service.',
  'bk.noRoom': 'No room',
  'bk.package': 'Package',
  'bk.packageHelp': 'Optional — an ad-hoc booking without a package is fully valid.',
  'bk.packageChoiceTitle': 'Which package should this session use?',
  'bk.packageChoiceSub':
    'Packages holding this same service. Nothing is picked automatically; reception decides.',
  'bk.packageCard': '{planned} planned · {remaining} remaining to schedule · {prov}',
  'bk.overScheduleReason': 'Reason for booking beyond the plan (optional)',
  'bk.overScheduleReasonHelp': 'Kept on the booking for whoever reviews the package.',
  'bk.warnOverTitle': 'Booked beyond the package plan',
  'bk.warnOverBody':
    '{planned} planned · {delivered} delivered · {scheduled} scheduled — {over, plural, one {# booking} other {# bookings}} beyond the plan, this one included. The booking is confirmed; a session past the plan is delivered at the catalogue price.',
  'bk.warnUpfrontTitle': 'Upfront payment expected',
  'bk.warnUpfrontBody':
    'This package expects payment upfront: {received} of {total} received, {shortfall} outstanding. The booking is confirmed — this is information for reception.',
  'bk.warnDismiss': 'Got it',
  'bk.overReasonLine': 'Booked beyond the plan — {reason}',
  'bk.packageOver': '{n, plural, one {# booking} other {# bookings}} beyond the plan',
  'bk.packageOverDelivered': '{n, plural, one {# delivery} other {# deliveries}} beyond the plan',
  'bk.noPackage': 'Without a package',
  'bk.noPackageBody': 'A valid ad-hoc session — no service is ever forced into a package.',
  'bk.overSchedule':
    'This line has no session left to schedule ({planned} planned · {delivered} delivered · {scheduled} scheduled). Booking still goes ahead — the package will be beyond its plan, and a session past the plan is delivered at the catalogue price.',
  'bk.address': 'Visit address',
  'bk.addressHelp':
    'Prefilled from the record — editable for this booking and stored on it; no place record is invented.',
  'bk.travel': 'Travel allowance',
  'bk.travelHelp':
    'Minutes each way, home visits only — editable per booking. Left empty, the clinic’s default of {n} minutes each way applies (Clinic setup → Profile).',
  'bk.travelHelpUnknown':
    'Minutes each way, home visits only — editable per booking. Left empty, the clinic’s default applies; that default could not be read just now, so it is not shown here.',
  'bk.capableFailed': 'These options could not be loaded, so this list is incomplete.',
  'bk.capableFailedTitle': 'Some options could not be loaded',
  'bk.capableFailedBody':
    'The practitioners and rooms that support this service could not be read, so those lists are incomplete — this is not a statement that none exist. Try again, and ask a clinic administrator if it keeps failing.',
  'bk.confirm': 'Confirm the booking',
  'bk.saveNote': 'Hard constraints are checked on save — if it fails, nothing you typed is lost.',
  'bk.suggest': 'Suggest times',
  'bk.suggestSub':
    'Smart Scheduling offers valid slots for this package session — advisory only; pick one to fill the form.',
  'bk.suggestNone': 'No valid slot in the next {days, number} days.',
  'bk.suggestPick': 'Use this',
  'bk.whoFirst': 'Choose the service and the patient first.',

  'bk.refusedTitle':
    'The save was refused — {n, plural, one {# conflict} other {# conflicts, all at once}}',
  'bk.refusedBody':
    'Nothing was booked — and nothing was lost. Everything you typed is still here. Resolve the conflicts and save again.',
  'bk.noOverrideTitle': 'Why there is no override',
  'bk.noOverrideBody':
    'Time off, room clashes and the patient’s own overlap are the clinic system’s hard constraints; the UI builds no path around them.',
  'bk.way.time': 'Pick another time',
  'bk.way.practitioner': 'Change practitioner',
  'bk.way.room': 'Change room',
  'bk.v.BOOKING_PATIENT_OVERLAP': 'The patient already has another booking overlapping this time.',
  'bk.v.BOOKING_PRACTITIONER_OVERLAP': 'The practitioner is already booked in this window.',
  'bk.v.BOOKING_ROOM_OVERLAP': 'The room is already booked in this window.',
  // ZOY-650: the gap alone is the reason (the sessions do not touch).
  'bk.gap.practitioner':
    'The practitioner needs the clinic’s {n, plural, one {#-minute} other {#-minute}} gap before this session — the previous session ends too close. Start {n, plural, one {# minute} other {# minutes}} after it ends, or later.',
  'bk.gap.room':
    'The room needs its {n, plural, one {#-minute} other {#-minute}} gap before this session — the previous session in it ends too close.',
  'bk.v.BOOKING_OUTSIDE_WORKING_HOURS':
    'Outside the practitioner’s working hours — visible on the calendar as the tinted zone.',
  'bk.v.BOOKING_PRACTITIONER_TIME_OFF':
    'The practitioner is on time off then — visible on the calendar as the hatched layer.',
  'bk.v.BOOKING_PRACTITIONER_NOT_CAPABLE':
    'The practitioner does not hold the capability for this service.',
  'bk.v.BOOKING_PRACTITIONER_NOT_ACTIVE_MEMBER':
    'The practitioner is not an active member of this clinic.',
  'bk.v.BOOKING_DAILY_CAP_EXCEEDED': 'The practitioner’s daily session cap would be exceeded.',
  'bk.v.BOOKING_WEEKLY_CAP_EXCEEDED': 'The practitioner’s weekly session cap would be exceeded.',
  'bk.v.BOOKING_SERVICE_NOT_BOOKABLE': 'The service is not bookable at this clinic.',
  'bk.v.BOOKING_SERVICE_PRICE_NOT_CONFIGURED':
    'The service has no price configured yet — pricing is set in Clinic setup → Services before it can be booked.',
  'bk.v.BOOKING_SERVICE_LOCATION_NOT_ENABLED': 'The service is not offered in this delivery mode.',
  'bk.v.BOOKING_ROOM_DISABLED': 'The room is disabled.',
  'bk.v.BOOKING_ROOM_NOT_CAPABLE': 'The room is not set up for this service.',
  'bk.v.BOOKING_ROOM_OUTSIDE_WORKING_HOURS':
    'Outside the room’s hours — set under Clinic setup › Rooms, on the room itself.',
  'bk.v.BOOKING_ROOM_BLOCKOUT': 'The room is blocked out then.',
  'bk.v.BOOKING_INVALID_RANGE': 'The end must come after the start.',
  'bk.v.BOOKING_PACKAGE_STOPPED':
    'That package (or this service in it) was stopped by an End of treatment — nothing new can be booked on it. Book without the package, or record the patient’s return first.',
  'bk.packageStopped': 'Stopped by an End of treatment, so not offered for a new booking: {names}.',
  'bk.v.BOOKING_PACKAGE_ITEM_MISMATCH':
    'That package line does not belong to this patient and service.',
  'bk.v.BOOKING_ALREADY_DELIVERED':
    'This session was delivered — a delivered booking is a historical anchor and cannot change.',
  'bk.v.BOOKING_NOT_ACTIVE': 'This booking is no longer live.',
  'bk.v.other': 'The clinic system refused: {code}.',

  'bk.detailTitle': 'Booking',
  'bk.when': 'When',
  'bk.packageLine':
    '{name} — {planned} planned · {delivered} delivered · {scheduled} scheduled · {remaining} to schedule',
  'bk.noPackageLine': 'Ad-hoc — no package',
  'bk.colourNote':
    'The service is always written here and on the calendar — colour never stands alone.',
  'bk.reschedule': 'Reschedule',
  'bk.cancel': 'Cancel the booking',
  'bk.noShow': 'Mark no-show',
  'bk.threeTitle': 'Only three statuses',
  'bk.threeBody':
    'A booking is only booked, cancelled or no-show. There is no pending, confirmed, checked-in or in-progress; a past session’s Delivered derives from the session record.',
  'bk.sameKeyTitle': 'Cancel and no-show share a permission',
  'bk.sameKeyBody':
    'Both are irreversible, both take an optional reason — and neither consumes a package session; the planned session stays available to schedule again. Their difference is meaning: cancelled says the appointment was called off; no-show says it stood and the patient did not attend.',
  'bk.deliveredNote':
    'Delivered — derived from the session record; this booking is now a historical anchor and cannot be moved or cancelled (void the delivery first if it was an error).',
  'bk.reason': 'Reason',
  'bk.reasonGiven': 'Reason given: {reason}',
  'bk.createdLine': 'Booked by {who} · {date}',
  'bk.cancelTitle': 'Cancel this booking?',
  'bk.cancelBody':
    'The slot opens immediately and a planned package session returns to the remaining count. Cancelling is irreversible — the booking stays on record as cancelled, and a new one can be made any time. There is no fee.',
  'bk.keep': 'Keep the booking',
  'bk.noShowTitle': 'Mark this session as a no-show?',
  'bk.noShowBody':
    'Like cancelling, no package session is consumed and the planned session stays available to schedule again — the difference is what it means: the appointment stood, and the patient did not attend. The mark is irreversible and the booking stays visible with its no-show state.',
  'bk.goBack': 'Go back',
  'bk.openPatient': 'Open the record',
  'bk.openPackage': 'Open the package',

  'bk.rsTitle': 'Reschedule',
  'bk.rsSub':
    'Move when, who, and how it is delivered — this same booking, never a new one, and never another package session.',
  'bk.rsWhere': 'Where and when',
  'bk.rsDurationHelp': 'Stays the same unless you change it.',
  'bk.rsPractitionerHelp': 'May move to another capable practitioner.',
  'bk.rsModeHelp':
    'Fields follow the mode: at-home swaps the room for the visit’s address and travel allowance; in-clinic brings back the optional room — never auto-selected.',
  'bk.rsCta': 'Move the booking',
  'bk.rsUnchanged':
    'Nothing has changed yet — adjust the time, practitioner, room or delivery mode first.',
  'bk.rsNote': 'Hard constraints are re-checked on save — a refusal loses nothing.',
  'bk.rsNoServiceTitle': 'Service and package do not change here — for now',
  'bk.rsNoServiceBody':
    'A reschedule moves this booking’s time, practitioner, room and delivery mode. Its service and package stay as booked — to change those, cancel and book anew.',
  'bk.rsLocked': 'This booking cannot be moved: {why}',

  'rec.bookingsSub': 'Every booking on this record, newest first.',
  'rec.noBookings': 'No bookings yet. The first one is made from the calendar.',
  'rec.newBooking': 'New booking',

  'hours.affected':
    '{n, plural, =0 {No booked sessions fall inside this time off.} one {# booked session falls inside this time off — open the calendar to move it.} other {# booked sessions fall inside this time off — open the calendar to move them.}}',
  'md.title': 'My Day',
  'md.sub': 'Your own schedule, on any screen.',
  'md.summary':
    '{n, plural, =0 {No sessions today} one {# session} other {# sessions}}{home, plural, =0 {} one { · one at a family’s home} other { · # at families’ homes}}',
  'md.empty': 'Nothing on your schedule today.',
  'md.stale': 'Couldn’t refresh just now — this is your schedule as it was last loaded.',
  'md.notPractitioner':
    'Your account has no sessions of its own today. The clinic calendar shows everyone’s.',
  'md.openCalendar': 'Open the calendar',
  'md.addressOnBooking': 'address on the booking',
  'md.packageLeft': '{name} · {n} left to schedule',

  'sp.title': 'Plan {name}’s remaining sessions',
  'sp.sub':
    'For {line} — {n, plural, one {# session} other {# sessions}} remaining to schedule. Suggestions are advisory: edit or ignore them freely.',
  'sp.none': 'Nothing remaining to schedule on this line.',
  'sp.strategy.preferred_fit': 'Preferred fit',
  'sp.strategy.preferred_fitBody': 'Leans on the family’s usual times and the preferred therapist.',
  'sp.strategy.steady_rhythm': 'Steady rhythm',
  'sp.strategy.steady_rhythmBody':
    'The same weekday and time every week — even if it finishes later.',
  'sp.strategy.soonest_completion': 'Soonest completion',
  'sp.strategy.soonest_completionBody': 'The earliest free slots, even across practitioners.',
  'sp.prefs': 'Preferences (soft — ranking only)',
  'sp.prefPractitioner': 'Preferred practitioner',
  'sp.prefRoom': 'Preferred room',
  'sp.prefRoomHelp':
    'Suggestions carry no room unless you name one here; it is carried, never chosen.',
  'sp.horizon': 'Plan ahead (days)',
  'sp.planHead': 'A suggestion for {n, plural, one {# session} other {# sessions}}',
  'sp.planSub':
    'Each suggestion’s score, reasons and trade-offs are written in human words. Every session can be kept or left out. Suggestions carry no room — the scheduler never searches or picks one.',
  'sp.fitWell': 'Fits well · {score}',
  'sp.fit': 'Fits · {score}',
  'sp.keep': 'Keep',
  'sp.incomplete':
    'Could not fit every session within the horizon — extend it or plan the rest later.',
  'sp.rhythmBroken': 'The weekly rhythm breaks at least once within the horizon.',
  'sp.apply': 'Apply {n, plural, one {# session} other {# sessions}}',
  'sp.refresh': 'Refresh suggestions',
  'sp.applyNote':
    'Applied together or not at all — and every slot is re-checked against hard constraints on save.',
  'sp.staleTitle': 'Nothing was applied',
  'sp.staleBody':
    'The batch is all-or-nothing: a slot was taken by apply time, so no session was booked and your plan is untouched. The rows no longer offered are flagged; refresh and apply again.',
  'sp.staleRow': 'Slot taken since',
  'sp.applied': '{n, plural, one {# session} other {# sessions}} booked.',
  'sp.appliedWarn': 'Some of the bookings just made carry information:',
  'sp.advisoryTitle': 'Advisory, never in charge',
  'sp.advisoryBody':
    'Reception may edit or ignore any suggestion; hard constraints still decide at final save. A first contact never comes through here — the first booking is always manual, from the calendar.',
  'sp.planLine': 'Plan remaining sessions',
  'sp.r.PREFERRED_PROVIDER': 'the preferred therapist for this service',
  'sp.r.STRONG_CAPABILITY_MATCH': 'a strong capability match',
  'sp.r.USUAL_PRACTITIONER': 'the same therapist as before',
  'sp.r.AVAILABLE_SOON': 'available soon',
  'sp.r.LOW_PRACTITIONER_LOAD': 'a lighter load for this therapist',
  'sp.r.MATCHES_PREFERRED_PRACTITIONER': 'your preferred practitioner',
  'sp.r.MATCHES_PREFERRED_ROOM': 'your preferred room',
  'sp.r.MATCHES_PREFERRED_WEEKDAY': 'a preferred weekday',
  'sp.r.MATCHES_PREFERRED_TIME_WINDOW': 'a preferred time of day',
  'sp.t.DIFFERENT_PRACTITIONER_THAN_USUAL': 'a different therapist than usual',
  'sp.t.DIFFERENT_PRACTITIONER_THAN_PREFERRED': 'not the preferred practitioner',
  'sp.t.DIFFERENT_ROOM_THAN_PREFERRED': 'not the preferred room',
  'sp.t.OUTSIDE_PREFERRED_WEEKDAYS': 'outside the preferred weekdays',
  'sp.t.OUTSIDE_PREFERRED_TIME_WINDOWS': 'outside the preferred hours',
  'sp.tradeoff': 'Trade-off: {text}.',
  'sp.reason': '{text}.',
  /* Session execution lifecycle (ZOY-546/551). */
  'bk.status.incomplete': 'Incomplete',
  'bk.exec.in_progress': 'In progress',
  'bk.startCta': 'Start the session',
  'bk.startTitle': 'Start the session?',
  'bk.startBody':
    'Starting records the time and your name, and the clinical work proceeds inside this session.',
  'bk.yes': 'Yes',
  'bk.no': 'No',
  'bk.startedLine': 'Started by {who} · {date}',
  'bk.err.alreadyStarted': 'This session had already been started — showing its current state.',
  'bk.guestNoStart':
    'Registration for this patient is incomplete, so the clinical session cannot be started. Registration is completed from the patient record; the booking itself stays valid.',
  'bk.incCta': 'Close as incomplete',
  'bk.incTitle': 'Close this session as incomplete?',
  'bk.incBody':
    'The visit happened but the clinical work could not be completed. Nothing is payable, no package progress moves, and the session can never be recorded as delivered afterwards.',
  'bk.incReason': 'Why the session was not completed',
  'bk.err.notStarted':
    'Only a started session can be closed as incomplete — a session that never happened is a cancellation instead.',
  'bk.assessNeeded':
    'Completing this session requires this session\u2019s own signed-off assessment.',
  // Smart Scheduling v2 (ZOY-682)
  'sp.subPackage':
    '{pkg} — {n, plural, one {# session} other {# sessions}} remaining across {k, plural, one {# service} other {# services}}. Choose the options; suggestions are built inside them.',
  'sp.opt.title': 'Scheduling options',
  'sp.opt.sub': 'Always: one session of each service per day, and at most two sessions a day.',
  'sp.opt.dayPattern': 'Day pattern',
  'sp.opt.fastest': 'Fastest',
  'sp.opt.weekdays': 'Selected weekdays',
  'sp.opt.weekdaysHelp': 'Each selected day carries at most one session of each service.',
  'sp.opt.weekdaysNeeded': 'Select at least one day.',
  'sp.opt.presetEven': 'Even days',
  'sp.opt.presetOdd': 'Odd days',
  'sp.opt.therapist': 'Therapist',
  'sp.opt.tAny': 'Any capable therapist',
  'sp.opt.tUsual': 'Usual therapist',
  'sp.opt.tSpecific': 'Specific therapist',
  'sp.opt.tFor': 'Therapist for {service}',
  'sp.opt.therapistNeeded': 'Choose a therapist for every service.',
  'sp.wd.1': 'Monday',
  'sp.wd.2': 'Tuesday',
  'sp.wd.3': 'Wednesday',
  'sp.wd.4': 'Thursday',
  'sp.wd.5': 'Friday',
  'sp.wd.6': 'Saturday',
  'sp.wd.7': 'Sunday',
  'sp.model.soonest_completion': 'Soonest completion',
  'sp.model.soonest_completionBody': 'The package finishes earliest.',
  'sp.model.steady_time': 'Steady time',
  'sp.model.steady_timeBody': 'The same time of day for each session wherever possible.',
  'sp.model.best_fit': 'Best fit',
  'sp.model.best_fitBody': 'Usual therapist, most same-day pairing, balanced load.',
  'sp.unavailableSpecific':
    'No complete plan is possible with the chosen therapist, so nothing is offered under this option. Change the therapist or the day pattern.',
  'sp.noPlans': 'No plan could be built within the horizon.',
  'sp.horizonNote': 'Search horizon: {days, number} days',
  'sp.paired': 'Two sessions back to back',
  'sp.notPaired': 'Not paired',
  'sp.noUsual':
    'No usual therapist is known for every service; any capable therapist was used for those.',
  'sp.steadyNotHeld': 'One time of day could not be held for every session.',
  'sp.applyBatches':
    'More than {max, number} sessions apply in batches; each batch is all-or-nothing.',
  'sp.appliedPartial': '{n, number} sessions were applied; the next batch was refused.',
  'sp.r.PAIRED_SAME_DAY': 'back to back with the other service',
  'sp.t.NOT_PAIRED_ON_DAY': 'not paired with the other service that day',
  // ZOY-685/686: the group occurrence — one session, its attendees.
  'grp.newTitle': 'New group session',
  'grp.newSub':
    'One session, several attendees — like a calendar event. Pick the group service, the therapist, when and how; add the attendees afterwards. Each attendee keeps their own package and payment.',
  'grp.service': 'Group service',
  'grp.serviceHelp': 'Services with the group workflow only.',
  'grp.noGroupServices':
    'No group service is enabled yet — create one under Clinic setup › Services with the “Group session” workflow.',
  'grp.capacity': 'Capacity',
  'grp.capacityHelp':
    'Maximum attendees. Prefilled from the service; up to {cap, number} for this mode.',
  'grp.createCta': 'Create the group session',
  'grp.step2': '2 · Time, therapist, place',
  'grp.title': 'Group session',
  'grp.sub': 'The session and its attendees. Delivery, outcome and payment stay per attendee.',
  'grp.attendees': 'Attendees',
  'grp.attendeesSub':
    'Registered patients only. Each keeps their own package line or ad-hoc price.',
  'grp.add': 'Add an attendee',
  'grp.addSearch': 'Find a registered patient',
  'grp.addSearchHelp': 'Last name, file number or mobile. Guests cannot join a group session.',
  'grp.addNone': 'No registered patient matches.',
  'grp.addPick': 'Add',
  'grp.addPackageTitle': 'Which package should this attendee use?',
  'grp.addCta': 'Add to the session',
  'grp.full': 'The session is full ({cap, number}).',
  'grp.remove': 'Remove',
  'grp.removeTitle': 'Remove this attendee?',
  'grp.removeBody':
    'Their booking is cancelled (nothing consumed from the package) and they leave this session only. Possible before the start.',
  'grp.noAttendees': 'No attendees yet — add the first one.',
  'grp.start': 'Start the group session',
  'grp.startTitle': 'Start the group session?',
  'grp.startBody':
    'Every registered attendee’s session starts now, in your name. Delivery is then recorded per attendee.',
  'grp.startedNot':
    '{n, plural, one {# attendee} other {# attendees}} could not start (registration incomplete).',
  'grp.end': 'End the group session',
  'grp.endTitle': 'End the group session?',
  'grp.endBody':
    'The session is over. Each attendee is still delivered, marked no-show or closed on their own booking.',
  'grp.cancel': 'Cancel the group session',
  'grp.cancelTitle': 'Cancel the group session?',
  'grp.cancelBody':
    'Every attendee’s booking is cancelled with it. Irreversible; nothing is consumed from any package.',
  'grp.cancelled': 'This group session was cancelled.',
  'grp.move': 'Move the session',
  'grp.moveSub':
    'Time, therapist, room and destination — every attendee follows. Not after the start.',
  'grp.moveCta': 'Move the group session',
  'grp.deliver': 'Record delivery',
  'grp.noShow': 'No-show',
  'grp.viewBooking': 'Booking',
  'grp.guestSkipped': 'Registration incomplete — not started',
  'grp.reportTitle': 'Group report',
  'grp.reportSub':
    'One report for the whole session, written once by the leading therapist after the start; it then appears on every attendee’s session record. Private notes stay on each attendee’s delivery.',
  'grp.reportWrite': 'Write the group report',
  'grp.reportPh': 'What the group worked on, how the session went…',
  'grp.reportCta': 'Save the report — final',
  'grp.reportNote': 'Write-once, like session notes: no edit or delete afterwards.',
  'grp.reportBy': 'Written by {who} · {when}',
  'grp.reportNone': 'No report yet.',
  'grp.reportBeforeStart': 'The report is written after the session has started.',
  'grp.reportNotLeading': 'Only the leading therapist writes the group report.',
  'grp.movedNote': 'Every attendee’s booking moved with the session.',
  'grp.facts.capacity': 'Capacity',
  'grp.facts.therapist': 'Leading therapist',
  // Attendees chosen while creating the occurrence (this occurrence only).
  'grp.step3': '3 · Attendees',
  'grp.draftSub':
    'The attendees of this session only — registered patients, chosen fresh for every session. Each keeps their own package or ad-hoc price.',
  'grp.draftNone': 'No attendees chosen yet.',
  'grp.draftRemove': 'Remove',
  'grp.draftCount':
    '{n, plural, =0 {No attendees} one {# attendee} other {# attendees}} · {cap, number} places',
  'grp.createWith':
    '{n, plural, =0 {Create the group session} one {Create with # attendee} other {Create with # attendees}}',
  'grp.emptyTitle': 'Create the group session without attendees?',
  'grp.emptyBody':
    'The session is created empty; attendees can be added on the session page until it starts. Usually the attendees are chosen now.',
  'grp.emptyCta': 'Create without attendees',
  'grp.addFailedTitle':
    'The session was created, but {n, plural, one {# attendee} other {# attendees}} could not be added',
  'grp.addFailedLine': '{name}: {reason}',
  'grp.addFailedUnknown':
    'no answer from the server — check the list below and add again if needed',
  'grp.addFailedDismiss': 'Understood',
  'grp.err.GROUP_SESSION_FULL': 'The session is full.',
  'grp.err.GROUP_SESSION_PATIENT_ALREADY_IN': 'This patient is already in the session.',
  'grp.err.GROUP_SESSION_CAPACITY_EXCEEDS_LIMIT': 'Capacity is above the limit for this mode.',
  'grp.err.GROUP_SESSION_CAPACITY_REQUIRED': 'Set a capacity — the service has no default.',
  'grp.err.GROUP_SESSION_MODE_NOT_ALLOWED':
    'A group session is in clinic or online — never at home.',
  'grp.err.GROUP_SESSION_SERVICE_NOT_GROUP': 'This service is not a group service.',
  'grp.err.GROUP_SESSION_PARTICIPANT_OVERLAP':
    'Moving would put an attendee into two sessions at once.',
  'grp.err.GROUP_SESSION_NOT_ACTIVE': 'This group session is cancelled.',
  'grp.err.GROUP_SESSION_ALREADY_STARTED': 'The group session has already started.',
  'grp.err.GROUP_SESSION_NOT_STARTED': 'The group session has not started yet.',
  'grp.err.GROUP_SESSION_ALREADY_ENDED': 'The group session has already ended.',
  'grp.err.GROUP_SESSION_ONLINE_SESSION_LOCKED':
    'The online session has already opened; it can no longer be moved, cancelled or emptied.',
  'grp.err.GROUP_REPORT_ALREADY_WRITTEN': 'The group report was already written.',
  'grp.err.GROUP_SESSION_PRACTITIONER_OVERLAP': 'The therapist is already booked in this window.',
  'grp.err.GROUP_SESSION_ROOM_OVERLAP': 'The room is already booked in this window.',
  'grp.err.BOOKING_PATIENT_OVERLAP': 'This patient already has another session at that time.',
  // ZOY-696: the therapist's hosted-video surface.
  'live.title': 'Live session',
  'live.role.host': 'Host',
  'live.role.cohost': 'Co-host',
  'live.connecting': 'Connecting to the video room…',
  'live.permissions': 'Camera and microphone permission is needed to join with video.',
  'live.permissionDenied':
    'Camera or microphone was refused — you are in the room without media. Allow them in the browser and rejoin.',
  'live.notConfigured': 'The video platform is not configured for this deployment.',
  'live.you': 'You',
  'live.leave': 'Leave',
  'live.end': 'End for everyone',
  'live.endTitle': 'End the session for everyone?',
  'live.endBody':
    'Every family is disconnected and the room closes. Delivery is still recorded on the booking afterwards.',
  'live.mic': 'Microphone',
  'live.cam': 'Camera',
  'live.on': 'on',
  'live.off': 'off',
  'live.stage': 'On stage',
  'live.audience':
    '{n, plural, =0 {No one in the audience} one {# in the audience} other {# in the audience}}',
  'live.hands': 'Raised hands',
  'live.invite': 'Invite to stage',
  'live.dismissHand': 'Dismiss',
  'live.mute': 'Mute',
  'live.toAudience': 'To audience',
  'live.remove': 'Remove',
  'live.promote': 'Make co-host',
  'live.reconnecting': 'Connection lost — reconnecting…',
  'live.ended': 'The session has ended.',
  'live.removed': 'You were removed from the session.',
  'live.noRecording': 'This session is not recorded.',
  'live.controlFailed': 'That did not go through — try again.',
  'live.backTo': 'Back to the booking',

  /* ── Session sheet (fast actions over the calendar) ───────────────────── */
  'sheet.title': 'Session',
  'sheet.close': 'Close',
  'sheet.openFull': 'Full details',
  'sheet.back': '← Back to the session',
  'sheet.payment': 'Payment',
  'sheet.owed': '{amount} outstanding',
  'sheet.guest': 'Guest',
  'sheet.done.cancel': 'Cancelled — the calendar is updated.',
  'sheet.done.no_show': 'Marked no-show — the calendar is updated.',
  'sheet.done.paid': 'Payment recorded.',
  'sheet.done.moved': 'Moved — the calendar is updated.',
  'md.unrec.title': 'Reports not recorded',
  'md.unrec.sub':
    'Your sessions of the last {days, number} days whose time has passed and that still have no report.',
  'md.unrec.groupReport': 'Group report not written',
  'md.unrec.record': 'Record report',
  'md.unrec.writeGroup': 'Write group report',
  'sheet.extras': 'Extra charges',
  'cal.print.open': 'Print / PDF',
  'cal.print.title': 'Print the schedule',
  'cal.print.sub':
    'One sheet of A4. In the print window choose a printer — or “Save as PDF” to keep a file.',
  'cal.print.kind': 'Schedule',
  'cal.print.kind.day': 'One day',
  'cal.print.kind.week': 'One week',
  'cal.print.whichDay': 'Which day',
  'cal.print.whichWeek': 'Which week',
  'cal.print.today': 'Today',
  'cal.print.tomorrow': 'Tomorrow',
  'cal.print.otherDay': 'Another day',
  'cal.print.thisWeek': 'This week',
  'cal.print.nextWeek': 'Next week',
  'cal.print.otherWeek': 'Another week',
  'cal.print.date': 'Date',
  'cal.print.weekOf': 'A day in that week',
  'cal.print.who': 'Therapist',
  'cal.print.all': 'All therapists',
  'cal.print.count': '{n, plural, one {# session} other {# sessions}} in this range',
  'cal.print.none': 'No session in this range.',
  'cal.print.go': 'Print / Save as PDF',
  'cal.print.dayTitle': 'Day schedule — {date}',
  'cal.print.weekTitle': 'Week schedule — {from} to {to}',
  'cal.print.forWho': 'Therapist: {name}',
  'cal.print.printedAt': 'Printed {when}',
  'cal.print.colTherapist': 'Therapist',
  'cal.print.colDay': 'Day',
  'cal.print.layout': 'Week as',
  'cal.print.layout.grid': 'Day tables',
  'cal.print.layout.list': 'By therapist',
  'cal.print.layout.gridAllHint':
    'Each day on its own page, laid out like the day print: therapists down, hours across.',
  'cal.print.layout.gridOneHint': 'One page: the days down, the hours across.',
  'cal.print.layout.listHint':
    'One block per therapist; the same session on several days reads as one line.',
  'cal.print.span': '{from}–{to}',
  'cal.print.group': 'Group',
  'cal.print.sessions': '{n, plural, one {# session} other {# sessions}}',
  'bk.pick.offeredHelp': 'Practitioners who offer this service and work at this time.',
  'bk.pick.none':
    'No practitioner of this service works at this time — search another by name below.',
  'bk.pick.search': 'Another practitioner',
  'bk.pick.searchHelp':
    'Search by name — {n, plural, one {# practitioner} other {# practitioners}} of this service outside their working hours at this time.',
  'bk.pick.outside': 'Outside this practitioner’s working hours',
  'bk.pick.timeOff': 'This practitioner is on leave at this time',
  'bk.pick.choose': 'Choose',
  'bk.pick.noMatch': 'No match.',
  // 2026-10-14: payment before delivery, from the sheet (general credit).
  'sheet.prepay': 'Record payment',
  'sheet.done.prepaid': 'Payment recorded on the patient’s account.',
  // 2026-10-18: repeat a new booking on chosen weekdays.
  'bk.rep.toggle': 'Repeat',
  'bk.rep.toggleHelp':
    'Book the same session at this time on chosen weekdays — each date becomes its own booking.',
  'bk.rep.on': 'On',
  'bk.rep.off': 'Off',
  'bk.rep.days': 'On these days',
  'bk.rep.every': 'How often',
  'bk.rep.every.1': 'Every week',
  'bk.rep.every.2': 'Every other week',
  'bk.rep.every.3': 'Every third week',
  'bk.rep.every.4': 'Once a month',
  'bk.rep.count': 'Number of sessions',
  'bk.rep.countHelp': 'From 1 to {max, number}, starting on the booking’s date.',
  'bk.rep.spanMonths': 'About {n, plural, one {# month} other {# months}} of sessions.',
  'bk.rep.spanYears': 'About {n, plural, one {# year} other {# years}} of sessions.',
  'bk.rep.fill': 'Complete the count with later dates',
  'bk.rep.fillHelp': 'An unticked date is replaced by the next date of the pattern.',
  'bk.rep.replacing':
    '{n, plural, one {# replacement session} other {# replacement sessions}} from {date}.',
  'bk.rep.previewTitle': 'Dates',
  'bk.rep.chosen': '{n, plural, one {# date chosen} other {# dates chosen}}',
  'bk.rep.progress': 'Booking {done, number} of {total, number}…',
  'bk.rep.free': 'Free',
  'bk.rep.issue.holiday': 'Official holiday',
  'bk.rep.issue.outside_hours': 'Outside working hours',
  'bk.rep.issue.time_off': 'Practitioner on leave',
  'bk.rep.issue.practitioner_busy': 'Practitioner already booked',
  'bk.rep.issue.patient_busy': 'Patient already booked',
  'bk.rep.save': '{n, plural, =0 {Book the sessions} one {Book # session} other {Book # sessions}}',
  'bk.rep.booked': 'Booked',
  'bk.rep.notBooked': 'Not booked',
  'bk.rep.unknown': 'Unknown — check the calendar',
  'bk.rep.summary':
    '{booked, plural, one {# session booked} other {# sessions booked}}; {failed, plural, =0 {none refused} one {# not booked} other {# not booked}}.',
  'bk.rep.overPlan':
    '{n, plural, one {# session is} other {# sessions are}} beyond the package plan.',
  'bk.rep.unknownNote':
    'A date marked “unknown” did not answer in time — it may have been booked; check the calendar before booking it again.',
  'bk.rep.replace':
    'Add {n, plural, one {# session} other {# sessions}} after {date} in their place',
  'bk.rep.needForm': 'Choose the practitioner, date and time above first — the dates follow them.',
  'bk.rep.toCalendar': 'Go to the calendar',
  'bk.series.scope': 'This session or the series',
  'bk.series.one': 'Only this session',
  'bk.series.following':
    '{n, plural, one {This and # following session} other {This and # following sessions}}',
  'bk.series.moveHelp':
    'The later booked sessions of this series move the same way, each in its own week — one by one, each judged on its own.',
  'bk.series.cancelHelp': 'The later booked sessions of this series are cancelled too, one by one.',
  'bk.series.resultTitle': 'The following sessions',
  'bk.series.moved': 'Moved',
  'bk.series.to': '→',
  'bk.series.notMoved': 'Not moved',
  'bk.series.cancelled': 'Cancelled',
  'bk.series.notCancelled': 'Not cancelled',
  'bk.series.moveSummary':
    '{done, plural, one {# following session moved} other {# following sessions moved}}; {failed, plural, =0 {none refused} one {# stays where it was} other {# stay where they were}}.',
  'bk.series.cancelSummary':
    '{done, plural, one {# following session cancelled} other {# following sessions cancelled}}; {failed, plural, =0 {none refused} one {# not cancelled} other {# not cancelled}}.',
  'bk.series.progress': 'Working on {done, number} of {total, number}…',
  'bk.series.done': 'Done',
  'grp.rep.toggleHelp':
    'Create this group session at this time on chosen weekdays, with the same attendees each time — every date is its own session.',
  'grp.rep.save':
    '{n, plural, =0 {Create the sessions} one {Create # group session} other {Create # group sessions}}',
  'grp.rep.summary':
    '{booked, plural, one {# group session created} other {# group sessions created}}; {failed, plural, =0 {none refused} one {# not created} other {# not created}}.',
  'grp.rep.overPlan':
    '{n, plural, one {On # date} other {On # dates}} an attendee went beyond their package plan.',
  'grp.rep.notAdded': 'Not added: {names}',
  'grp.rep.notAddedTotal':
    '{n, plural, one {# attendee could not be added} other {# attendees could not be added}} — open the session to see who and why.',
};
